import React, { useState, useEffect } from 'react';

// Eid ul Adha 2026 Pakistan — approximately June 6, 2026
const EID_DATE = new Date('2026-06-06T00:00:00+05:00');

function getTimeLeft() {
  const now = new Date();
  const diff = EID_DATE - now;
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  return { days, hours, minutes, seconds, done: false };
}

function TimeUnit({ value, label }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      background: 'linear-gradient(135deg, rgba(255,107,157,0.1), rgba(168,85,247,0.08))',
      border: '1px solid rgba(255,107,157,0.2)',
      borderRadius: 20, padding: 'clamp(16px, 3vw, 28px) clamp(12px, 2.5vw, 28px)',
      minWidth: 'clamp(72px, 15vw, 110px)',
      position: 'relative', overflow: 'hidden',
      animation: 'countdown-pulse 1s ease-in-out infinite',
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg, rgba(255,107,157,0.05), rgba(168,85,247,0.03))',
      }} />
      <span style={{
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 900,
        fontSize: 'clamp(32px, 6vw, 56px)',
        lineHeight: 1,
        background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        position: 'relative',
      }}>
        {String(value).padStart(2, '0')}
      </span>
      <span style={{
        fontFamily: 'Nunito, sans-serif', fontSize: 'clamp(11px, 1.5vw, 14px)',
        color: '#9b7ba8', marginTop: 8, letterSpacing: '0.08em', textTransform: 'uppercase',
      }}>
        {label}
      </span>
    </div>
  );
}

export default function CountdownSection() {
  const [time, setTime] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="countdown" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0d0a14 0%, #100c1c 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Animated BG */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at 50% 50%, rgba(255,107,157,0.06) 0%, transparent 70%)',
        animation: 'gradient-move 8s ease infinite',
        backgroundSize: '200% 200%',
        pointerEvents: 'none',
      }} />

      {/* Stars */}
      {Array.from({ length: 20 }).map((_, i) => (
        <div key={i} style={{
          position: 'absolute',
          width: Math.random() * 3 + 1,
          height: Math.random() * 3 + 1,
          borderRadius: '50%',
          background: `rgba(255,255,255,${Math.random() * 0.5 + 0.1})`,
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animation: `twinkle ${2 + Math.random() * 3}s ease-in-out infinite`,
          animationDelay: `${Math.random() * 3}s`,
          pointerEvents: 'none',
        }} />
      ))}

      <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <div className="section-badge" style={{ margin: '0 auto 20px', display: 'inline-flex' }}>
          <span>🌙</span> Chapter 9
        </div>
        <h2 style={{
          fontFamily: 'Poppins, sans-serif', fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 58px)', lineHeight: 1.15, marginBottom: 8,
        }}>
          Waiting for <span className="gradient-text">Next Chat</span>
        </h2>
        <div className="section-divider center" />
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          padding: '8px 18px',
          background: 'rgba(255,107,157,0.08)',
          border: '1px solid rgba(255,107,157,0.2)',
          borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
          color: '#ff6b9d', marginBottom: 24,
        }}>
          🌙 Eid ul Adha — 6th June 2026
        </div>

        <p style={{
          fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
          color: '#9b7ba8', maxWidth: 520, margin: '0 auto 48px',
        }}>
          Hassan is counting every second until Eid ul Adha — when the next beautiful chapter begins. Here's the live countdown to that special day. 🌙✨
        </p>

        {/* Countdown */}
        {time.done ? (
          <div style={{
            padding: '40px',
            background: 'linear-gradient(135deg, rgba(255,107,157,0.1), rgba(168,85,247,0.1))',
            border: '1px solid rgba(255,107,157,0.3)',
            borderRadius: 28, marginBottom: 40,
          }}>
            <div style={{ fontSize: 60, marginBottom: 16 }}>🎉</div>
            <h3 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 28,
              background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text', marginBottom: 12,
            }}>Eid Mubarak! 🌙</h3>
            <p style={{ fontFamily: 'Nunito, sans-serif', fontSize: 16, color: '#9b7ba8' }}>
              The wait is over! May this Eid bring all the joy and happiness. 💕
            </p>
          </div>
        ) : (
          <div style={{
            display: 'flex', gap: 'clamp(8px, 2vw, 20px)', justifyContent: 'center',
            flexWrap: 'wrap', marginBottom: 48,
          }}>
            <TimeUnit value={time.days} label="Days" />
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 'clamp(24px, 4vw, 40px)', color: '#ff6b9d', fontWeight: 900, padding: '0 4px', fontFamily: 'Poppins, sans-serif' }}>:</div>
            <TimeUnit value={time.hours} label="Hours" />
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 'clamp(24px, 4vw, 40px)', color: '#ff6b9d', fontWeight: 900, padding: '0 4px', fontFamily: 'Poppins, sans-serif' }}>:</div>
            <TimeUnit value={time.minutes} label="Minutes" />
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 'clamp(24px, 4vw, 40px)', color: '#ff6b9d', fontWeight: 900, padding: '0 4px', fontFamily: 'Poppins, sans-serif' }}>:</div>
            <TimeUnit value={time.seconds} label="Seconds" />
          </div>
        )}

        {/* Pakistan time note */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 10,
          padding: '12px 24px',
          background: 'rgba(255,107,157,0.06)',
          border: '1px solid rgba(255,107,157,0.12)',
          borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 13,
          color: '#9b7ba8',
        }}>
          🕐 Pakistan Standard Time (PKT, UTC+5) • Live Update Every Second
        </div>
      </div>
    </section>
  );
}